export { ModalTitle } from "./ModalTitle";
export { ModalDescription } from "./ModalDescription";
export { isFromModal } from "./utils";
export { Modal, ModalTrigger, ModalContent, ModalBody, ModalFooter, ModalHeader } from "ics-ui-kit/components/modal";
